import { Link } from "react-router-dom";
import { useState } from "react";
import WhatsAppSelector from "../../../components/feature/WhatsAppSelector";

export default function CallToAction() {
  const [whatsappOpen, setWhatsappOpen] = useState<boolean>(false);

  return (
    <section 
      className="py-20 relative"
      style={{
        backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20printing%20workshop%20with%20professional%20equipment%2C%20vibrant%20printing%20materials%2C%20creative%20workspace%2C%20industrial%20printing%20machines%2C%20colorful%20inks%20and%20papers%2C%20professional%20lighting%2C%20clean%20organized%20environment%2C%20high-tech%20printing%20technology%2C%20commercial%20printing%20facility&width=1920&height=600&seq=cta-bg&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="absolute inset-0 bg-teal-600/80"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          ¿Listo para Impulsar tu Marca?
        </h2>
        <p className="text-xl text-gray-200 mb-8 max-w-3xl mx-auto">
          Tu marca no nació para pasar desapercibida. Hagámosla brillar con diseños que rompen esquemas y una impresión que impone presencia.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/contact"
            onClick={() => window.scrollTo(0, 0)}
            className="hidden lg:inline-flex bg-white text-teal-600 hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-200 whitespace-nowrap cursor-pointer items-center justify-center"
          >
            Solicitar Cotización Gratis
          </Link>
          <button
            onClick={() => setWhatsappOpen(true)}
            className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-200 flex items-center justify-center whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-fill mr-2"></i>
            Chatear por WhatsApp
          </button>
        </div>
      </div>

      <WhatsAppSelector
        isOpen={whatsappOpen}
        onClose={() => setWhatsappOpen(false)}
        productName="Consulta General"
      />
    </section>
  );
}